<template>
  <b-field :label="label">
    <qd-taginput
      v-model="selected"
      :icon="icon"
      :data="filtered"
      autocomplete
      :dropdown-position="dropdown"
      :type="type"
      :disabled="disabled"
      :loading="isFetching"
      :field="field"
      @typing="getFiltered"
      :open-on-focus="openOnFocus"
      @focus="onFocus">
      <template slot="empty">
        <div v-if="!isFetching">
          {{$t('general.autocomplete.noRslt')}}
        </div>
        <div v-else>{{$t('general.autocomplete.search')}}</div>
      </template>
      <template slot-scope="props">
        <slot v-bind="props"></slot>
      </template>
    </qd-taginput>
  </b-field>
</template>

<script>
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'queryTagInput',
  data() {
    return {
      icon: 'magnify',
      type: 'is-primary',
      isFetching: false,
      filtered: [],
    };
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    dropdown: {
      type: String,
      default: 'bottom',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    query: {
      type: Function,
      required: true,
      default: () => {},
    },
    field: {
      type: String,
      required: false,
      default: 'libelle',
    },
    selector: {
      type: String,
      required: false,
      default: 'id',
    },
    openOnFocus: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value ?? [];
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    onFocus() {
      if (this.openOnFocus && this.filtered.length === 0) {
        this.getFiltered();
      }
    },

    getFiltered: debounce(async function getItems(search) {
      if (!search && !this.openOnFocus) return;
      let items = [];
      this.isFetching = true;
      try {
        items = (await this.query(search)).data.result.items;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw (e);
      }
      this.filtered = items.filter((item) => {
        return !this.selected.map(
          itemselected => itemselected[this.selector],
        ).includes(item[this.selector]);
      });
      this.isFetching = false;
    }, 300),
  },
};
</script>
